var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Timeline',{attrs:{"id":_vm.handle,"sourceType":"profile","options":{ tweetLimit: '4' }}})}
var staticRenderFns = []

export { render, staticRenderFns }